/* Human Pro PDP - hero behaviour, part 2.
   Externalised from snippets/hpx-hero-js2.liquid on 23 Aug 2026: it is pure JS with no
   Liquid interpolation, so as an asset it is cached once and reused across every PDP
   instead of being re-sent inside each product page's HTML.

   ⚠️ BACKSLASHES. The first upload of this file doubled every backslash, because a
   GraphQL block string passes them through literally. "We\\'ll" ended the JS string
   early and the WHOLE FILE became a syntax error - addToCart, switchRpTab and
   submitBatchNotify were all silently undefined and the buy button did nothing.
   Single backslashes only, and prefer double-quoted JS strings for apostrophes.

   ⚠️ NO LIQUID IN THIS FILE either - that is the precondition for it being an asset.
   The notify-modal copy below therefore comes from window.HPX_I18N, printed inline by
   snippets/hpx-i18n-data BEFORE this file loads. */

/* ---- i18n -------------------------------------------------------------------
   Same pair as hpx-hero.js, defined here too so this file is self-sufficient if it
   ever loads without its sibling. Guarded: whichever file runs first wins and the
   other reuses it. hpxT substitutes the {{ token }} placeholders that arrive as
   literal text inside a translated value, and falls back to the English literal this
   file used to hardcode whenever the dictionary or the key is missing - a stale
   cached copy must never leave the button blank. */
window.hpxT = window.hpxT || function (key, vars, fallback) {
  var dict = window.HPX_I18N || {};
  var s = (typeof dict[key] === 'string' && dict[key] !== '') ? dict[key] : fallback;
  if (typeof s !== 'string') return '';
  if (!vars) return s;
  return s.replace(/\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g, function (m, name) {
    return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : m;
  });
};
window.hpxPlural = window.hpxPlural || function (base, count, vars, fallbackOne, fallbackOther) {
  var one = Number(count) === 1;
  return window.hpxT(base + (one ? '_one' : '_other'), vars, one ? fallbackOne : fallbackOther);
};

// Add to cart - Shopify: the selected pack drives the hidden variant id on the real product form.
function addToCart() {
  var sel = document.querySelector('.pack-card.selected');
  var form = document.getElementById('hpxProductForm');
  if (!sel || !form) return;
  var vid = document.getElementById('hpxVariantId');
  if (vid && sel.dataset.variantId) vid.value = sel.dataset.variantId;
  if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
}

/* Self-hosted videos: autoplay only when scrolled into view, pause when out.
   preload="none" + IntersectionObserver = no cost until the user actually sees them.

   ⚠️ THIS IS THE ONLY VIDEO OBSERVER ON A PDP. A second one was added on 22 Aug in
   snippets/hpx-video-autoplay (keyed on [data-hpx-autoplay]) without noticing this one
   existed, so both watched #europeVideo and #founderVideo and both called play(). Not
   harmful - play() is idempotent - but two observers on two 4-9MB videos is waste, and
   the duplicate has been unhooked. The reduced-motion guard from that version is kept
   below; it is the one thing it did better. */
document.addEventListener('DOMContentLoaded', function() {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function setupAutoplayOnView(videoId) {
    var video = document.getElementById(videoId);
    if (!video) return;
    var hasStartedLoading = false;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (!hasStartedLoading) {
            video.preload = 'auto';
            video.load();
            hasStartedLoading = true;
          }
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() { /* autoplay blocked by browser policy, silently ignore */ });
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });
    observer.observe(video);
  }
  setupAutoplayOnView('europeVideo');
  setupAutoplayOnView('founderVideo');
});

// Results panel tab switching
function switchRpTab(btn, tabId) {
  document.querySelectorAll('.rp-tab').forEach(function (t) { t.classList.remove('active'); });
  document.querySelectorAll('.rp-content').forEach(function (c) { c.classList.remove('active'); });
  btn.classList.add('active');
  var panel = document.getElementById(tabId);
  if (panel) panel.classList.add('active');
}

// Scroll-triggered animations (Intersection Observer)
(function() {
  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.ingredient-card, .mechanism-stage, .review-card, .product-card').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1), transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
    revealObserver.observe(el);
  });
})();

// Header shadow on scroll
window.addEventListener('scroll', function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  if (window.scrollY > 10) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}, { passive: true });

(function() {
  function syncViewport() {
    var bottom = window.visualViewport
      ? (window.visualViewport.offsetTop + window.visualViewport.height)
      : window.innerHeight;
    document.documentElement.style.setProperty('--vh-bottom', bottom + 'px');
  }
  window.addEventListener('scroll', syncViewport, { passive: true });
  window.addEventListener('touchmove', syncViewport, { passive: true });
  window.addEventListener('resize', syncViewport);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncViewport);
    window.visualViewport.addEventListener('scroll', syncViewport);
  }
  syncViewport();
})();

// Sticky bottom banner: pure CSS handles positioning (via --vh-bottom). JS only flips the
// .is-visible class to fade the banner in/out via opacity.
document.addEventListener('DOMContentLoaded', function() {
  var banner = document.getElementById('stickyBanner');
  var trigger = document.querySelector('.pack-options') || document.querySelector('.purchase-tabs');
  if (!banner || !trigger) return;
  function checkBanner() {
    banner.classList.toggle('is-visible', trigger.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', checkBanner, { passive: true });
  checkBanner();
});

// Sticky bar pack-selector dropdown: tap to open, tap option to pick (calls selectPack),
// tap outside to dismiss. Dropdown is positioned above the bar via CSS.
document.addEventListener('DOMContentLoaded', function() {
  var selector = document.getElementById('stickyPackSelector');
  var dropdown = document.getElementById('stickyPackDropdown');
  if (!selector || !dropdown) return;

  function closeDropdown() {
    dropdown.hidden = true;
    selector.setAttribute('aria-expanded', 'false');
  }
  function openDropdown() {
    dropdown.hidden = false;
    selector.setAttribute('aria-expanded', 'true');
  }
  selector.addEventListener('click', function(e) {
    e.stopPropagation();
    if (dropdown.hidden) openDropdown(); else closeDropdown();
  });

  dropdown.querySelectorAll('.sticky-pack-option').forEach(function(opt) {
    opt.addEventListener('click', function(e) {
      e.stopPropagation();
      var packNum = parseInt(this.getAttribute('data-pack-num'), 10);
      var packCards = document.querySelectorAll('.pack-card');
      var targetCard = packCards[packNum - 1];
      if (targetCard && typeof selectPack === 'function') {
        selectPack(targetCard, packNum);
      }
      closeDropdown();
    });
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('#stickyPackSelector') || e.target.closest('#stickyPackDropdown')) return;
    closeDropdown();
  });
});

/* Batch notify. The product name comes from the modal's data-product-title, set by
   hpx-overlays from the product being viewed. It used to be hardcoded to
   "Mushroom Essentials Complex", so every signup on every product was recorded in
   Klaviyo against MEC - which would have quietly corrupted the back-in-stock
   segmentation the moment a second product went live.

   The five strings the shopper sees now come from window.HPX_I18N. custom_source and
   the Klaviyo profile properties deliberately do NOT: they are analytics keys, and
   translating them would split one segment into one per language. */
function submitBatchNotify() {
  var emailInput = document.getElementById('notifyEmail');
  var btn = document.getElementById('notifySubmitBtn');
  var errorEl = document.getElementById('notifyError');
  var modal = document.getElementById('notifyModal');
  if (!emailInput || !btn || !errorEl) return;

  var productTitle = (modal && modal.dataset.productTitle) ? modal.dataset.productTitle : 'Unknown product';
  var email = emailInput.value.trim();
  var valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  if (!email || !valid.test(email)) {
    errorEl.textContent = hpxT('notify_invalid_email', null, "Please enter a valid email address.");
    errorEl.style.display = 'block';
    return;
  }

  errorEl.style.display = 'none';
  btn.disabled = true;
  btn.textContent = hpxT('notify_sending', null, 'Sending...');

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VUvfyf', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15'
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: productTitle + ' PDP batch notify',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Batch Notify Product': productTitle,
                  'Batch Notify Date': new Date().toISOString().split('T')[0]
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'UMsXEc'
            }
          }
        }
      }
    })
  })
  .then(function(response) {
    if (response.ok || response.status === 202) {
      btn.textContent = hpxT('notify_success', null, "Thanks! We will notify you.");
      btn.style.background = '#1a7a2e';
      emailInput.value = '';
      setTimeout(function() {
        if (modal) modal.style.display = 'none';
        btn.textContent = hpxT('notify_submit', null, 'Notify Me');
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    } else {
      throw new Error('Request failed');
    }
  })
  .catch(function() {
    errorEl.textContent = hpxT('notify_error', null, "Something went wrong. Please try again.");
    errorEl.style.display = 'block';
    btn.textContent = hpxT('notify_submit', null, 'Notify Me');
    btn.disabled = false;
  });
}